// extracted by mini-css-extract-plugin
export default {"features":"ReleaseNotesIssuesList_features_FxIqw","bugs":"ReleaseNotesIssuesList_bugs_IAGMT"};